import React, { useEffect, useState, useRef, useMemo } from "react";
import { withRouter, Link } from "react-router-dom";
import TableContainer from "../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  FormGroup,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getProjects as onGetProjects,
  addNewProject as onAddNewProject,
  updateProject as onUpdateProject,
  deleteProject as onDeleteProject,
  getAccounts,
} from "store/actions";
import { isEmpty } from "lodash";

//redux
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";

const ProjectsList = props => {
  //meta title
  document.title = "Projects List | RKI";

  const dispatch = useDispatch();
  const [project, setProjects] = useState();
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      status: project?.status ?? "",
      name: project?.name ?? "",
      developer: project?.developer ?? "",
      developer_id: project?.developer_id ?? "",
    },
    validationSchema: Yup.object({
      status: Yup.number().required(),
      name: Yup.string().required(),
      developer_id: Yup.number().required(),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateProject = {
          ...values,
          id: project.id,
        };

        // update user
        dispatch(onUpdateProject(updateProject));
        validation.resetForm();
        setIsEdit(false);
      } else {
        const newProject = {
          ...values,
        };
        // save new user
        dispatch(onAddNewProject(newProject));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { developers, projects } = useSelector(state => ({
    projects: state.projects.projects,
    developers: state.Accounts.accounts.filter(
      account => account.type === "developer"
    ),
  }));

  const [userList, setProjectList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const columns = useMemo(
    () => [
      // {
      //   Header: "#",
      //   Cell: () => {
      //     return <input type="checkbox" className="form-check-input" />;
      //   },
      // },
      {
        Header: "Status",
        accessor: "status",
        filterable: true,
      },
      {
        Header: "Name",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Developer",
        accessor: "developer",
        Cell: cellProps => cellProps.value?.name ?? "",
        filterable: true,
      },
      {
        Header: "Action",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleProjectClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (developers && !developers.length) {
      dispatch(getAccounts());
    }
    if (projects && !projects.length) {
      dispatch(onGetProjects());
      setIsEdit(false);
    }
  }, [dispatch]);

  useEffect(() => {
    setProjects(projects);
    setIsEdit(false);
  }, [projects]);

  useEffect(() => {
    if (!isEmpty(projects) && !!isEdit) {
      setProjects(projects);
      setIsEdit(false);
    }
  }, [projects]);

  const toggle = () => {
    setModal(!modal);
  };

  const handleProjectClick = arg => {
    setProjects(arg);
    setIsEdit(true);

    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = projects => {
    setProjects(projects);
    setDeleteModal(true);
  };

  const handleDeleteProject = () => {
    dispatch(onDeleteProject(project.id));
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleProjectClicks = () => {
    setProjectList("");
    setIsEdit(false);
    toggle();
  };

  const keyField = "id";

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProject}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Projects" breadcrumbItem="Projects List" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={projects}
                    isGlobalFilter={true}
                    isAddOptions={"Projects"}
                    handleOptionClicks={handleProjectClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Edit Project" : "Add Project"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <FormGroup>
                              <Label className="form-label">Status</Label>
                              <Input
                                name="status"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.status || ""}
                                invalid={
                                  validation.touched.status &&
                                  validation.errors.status
                                    ? true
                                    : false
                                }
                              />
                              <FormFeedback type="invalid">
                                {validation.touched.name &&
                                  validation.errors.name}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col xs={12}>
                            <FormGroup>
                              <Label className="form-label">Name</Label>
                              <Input
                                name="name"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  validation.touched.name &&
                                  validation.errors.name
                                    ? true
                                    : false
                                }
                              />
                              <FormFeedback type="invalid">
                                {validation.touched.name &&
                                  validation.errors.name}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                          <Col xs={12}>
                            <FormGroup>
                              <Label className="form-label">Developer</Label>
                              <Select
                                options={developers}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id}
                                value={validation.values.developer}
                                onChange={option =>
                                  validation.setFieldValue(
                                    "developer_id",
                                    option?.id
                                  )
                                }
                              />
                              <FormFeedback type="invalid">
                                {validation.touched.developer_id &&
                                  validation.errors.developer_id}
                              </FormFeedback>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Save
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ProjectsList);
